import { DropdownMenuLabel, Input, InputDecoration, InputGroup } from '@monksflow/monks-ui';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ProjectPickerSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  title?: string;
}

export function ProjectPickerSearch({
  searchQuery,
  onSearchChange,
  title,
}: ProjectPickerSearchProps) {
  const { t } = useTranslation('common');

  return (
    <div className="bg-background flex flex-col gap-1">
      <DropdownMenuLabel>
        {title ?? t('ui.projectPickerSearch.selectProjectsToSave')}
      </DropdownMenuLabel>
      <div className="px-1 pb-2">
        <InputGroup
          size="sm"
          className="w-full border-0 has-[input:focus-visible]:ring-0 has-[input:focus-visible]:ring-offset-0"
        >
          <InputDecoration muted>
            <Search className="size-3.5" />
          </InputDecoration>
          <Input
            placeholder={t('ui.projectPickerSearch.search')}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            aria-label={t('ui.projectPickerSearch.searchProjects')}
            className="border-0 bg-transparent"
          />
        </InputGroup>
      </div>
    </div>
  );
}
